export const NotFound = () => {
  return <p>NotFound</p>;
};
